import ConsolidatedShipping from './consolidated-shipping'

export default ConsolidatedShipping
